import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatTime' })
export class FormatTimePipe implements PipeTransform {
  public transform(value: number): any {
    const totalSeconds = Math.round(Number(value));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let formattedTime = `${seconds}s`;
    if (minutes) {
      formattedTime = `${minutes}m ` + formattedTime;
    }
    if (hours) {
      formattedTime = `${hours}h ` + formattedTime;
    }

    return formattedTime;
  }
}
